import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import PrivateLayout from "@/components/layout/auth/PrivateLayout";
import { PeriodFilter } from "@/components/ui/period-filter";
import { useI18n } from "@/hooks/useI18n";
import { AgencyOverviewTab } from "@/lib/dashboard/AgencyOverviewTab";
import { PERIOD_OPTIONS } from "@/lib/dashboard/periodOptions";
import { AgencyDashboardPeriod } from "@/integrations/supabase/rpc-types";

const AgencyOverviewSummary = () => {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();
  const [period, setPeriod] = useState<AgencyDashboardPeriod>("30d");

  // Advisor, clienti e viaggi erano tab di questa pagina: i vecchi link /overview?tab=...
  // proseguono sulla pagina Dati, che ora li ospita.
  const legacyTab = searchParams.get("tab");
  if (legacyTab && legacyTab !== "overview") {
    return <Navigate to={`/overview/data?tab=${encodeURIComponent(legacyTab)}`} replace />;
  }

  return (
    <PrivateLayout
      pageTitle={t("dashboard.overview.pageTitle")}
      pageDescription={t("dashboard.overview.pageDescription")}
      showBackButton={false}
    >
      <div className="xl:px-8 md:px-4 mt-4 mx-auto space-y-4">
        <div className="flex justify-end">
          <PeriodFilter
            options={PERIOD_OPTIONS.map((opt) => ({
              value: opt.value,
              label: t(opt.labelKey),
            }))}
            value={period}
            onChange={(value) => setPeriod(value as AgencyDashboardPeriod)}
            ariaLabel={t("dashboard.overview.periodLabel")}
          />
        </div>

        <AgencyOverviewTab period={period} />
      </div>
    </PrivateLayout>
  );
};

export default AgencyOverviewSummary;
